'use strict';

var carousel = require('../components/carousel');
var $ = require('jquery');
require('slick-carousel');

var $productFootbedSlider = $('.product-footbed-slider');
var $itemDetailsWrapper = $('.list-item-details-wrapper');
var $slickSliderFootbed = $('.slick-footbed-carousel');

import {debounce} from '../components/custom-lodash';

// Used on PDP FOOTBED section
// Get ID to tranform the % relative value in a pixel value
function footbedPosition() {
    $('.marks-item').each(function (i) {
        // Get the values present in the ID
        var idValues = $(this).attr('id');
        var valueX = idValues.substring(10, 13);
        var valueY = idValues.substring(14, 17);

        // size of the cicle (make the value count in the center, not in the edge)
        var valueCurcle = 35 / 2;

        // Get the size of the image div
        var valueHEIGHT = $('.footbed-left ').height();
        var valueWIDTH = $('.footbed-left ').width();

        // Transform the % relative value in exact pixel value
        var topX = (valueX * valueWIDTH) / 100 - valueCurcle;
        var topY = (valueY * valueHEIGHT) / 100 - valueCurcle;

        // Create the Top and left values in inline CSS
        $(this).css({top: topY});
        $(this).css({left: topX});
    });
}

/**
 * @description Initialize the footbed marks UI
 */
function initFootbedMarks() {
    var $productFootbed = $('.product-footbed');
    var $marks = $productFootbed.find('.footbed-left-marks li');
    var $bubbles = $productFootbed.find('.footbed-right .bubbles li');
    var $navLeft = $productFootbed.find('.nav-prev');
    var $navRight = $productFootbed.find('.nav-next');
    var footbedCarousel;
    var currentNum;
    // initialize carousel
    carousel.init();
    footbedCarousel = carousel.get($productFootbed.find('.carousel-container').setUniqueId());

    // initialize the click events for the marks
    $marks.each(function (index, el) {
        var $currentMark = $(el);
        $currentMark.on('click mouseover', function () {
            // set current active mark
            $marks.removeClass('active');
            $currentMark.addClass('active');
            // set current active carousel item
            footbedCarousel.goTo(index);
        });
    });

    $bubbles.each(function (index, el) {
        var $currentBubble = $(el);
        $currentBubble.on('click', function () {
            $marks.removeClass('active');
            currentNum = $bubbles.index($currentBubble);
            $marks.eq(currentNum).addClass('active');
        });
    });

    $navLeft.on('click', function () {
        var $bubbleActive = $('.bubble-ctr .bubble.active');
        setTimeout(function () {
            $bubbleActive.prev().click();
        }, 100);
    });

    $navRight.on('click', function () {
        var $bubbleActive = $('.bubble-ctr .bubble.active');
        setTimeout(function () {
            $bubbleActive.next().click();
        }, 100);
    });
}

/**
 * @description Initialize the footbed marks UI
 */
function initFootbedItems() {
    $slickSliderFootbed.on('init reInit', function () {
        var $itemDetails = $productFootbedSlider.find('.slick-current .list-item-details').html();
        $itemDetailsWrapper.html($itemDetails);
    });

    if (!$slickSliderFootbed.hasClass('slick-initialized')) {
        $slickSliderFootbed.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            dotsClass: 'slick-dots-custom',
            rtl: document.documentElement.lang === 'ar' ? true : false,
            variableWidth: true,
            speed: 800,
            prevArrow: $('.link-footbed.slick-prev')[0],
            nextArrow: $('.link-footbed.slick-next')[0],
            focusOnSelect: true,
            centerMode: true,
            centerPadding: '0px',
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        variableWidth: false,
                        fade: true,
                        cssEase: 'linear'
                    }
                }
            ]
        });
    }

    $slickSliderFootbed.on('afterChange', function () {
        var $itemDetails = $productFootbedSlider.find('.slick-current .list-item-details').html();
        $itemDetailsWrapper.html($itemDetails);
    });
}

function footbed() {
    var $window = $(window);

    initFootbedItems();
    footbedPosition();
    initFootbedMarks();

    // Run on resize
    $window.on(
        'resize orientationchange',
        debounce(function () {
            initFootbedItems();
            footbedPosition();
            initFootbedMarks();
        }, 10)
    );
}

module.exports = {
    init: function () {
        footbed();
    }
};
